import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { FilterModalProps } from "./types";
import {
  DivFooterModalBackground,
  DivFooterModal,
  FilterModalHeaderMobile,
  FieldSearchMobile,
  FilterModalModalContent,
  FilterModalModalHeader,
  IconContent,
  InfoContent,
  FilterModalModalFooter,
} from "./styles";
import { Button } from "Components/atoms/Button";
import { FaArrowLeft } from "react-icons/fa";
import { FlightsFilter } from "Components/organisms/FlightsFilter/Mobile";
import { theme } from "styles/theme";
import { Typography } from "Components/atoms/Typography";
import { GroupButton } from "Components/atoms/GroupButton";

export const FilterModal: React.FC<FilterModalProps> = ({
  isVisibleModal,
  onClose,
  scrollToFilter = null,
}) => {
  const previousScrollYRef = useRef<number>(0);
  const sellerRef = useRef<HTMLDivElement>(null);
  const [selected, setSelected] = useState("aplicar");
  const [filterAction, setFilterAction] = useState<
    "apply" | "clean" | "default"
  >("default");

  const options = [
    { label: "Limpar", value: "limpar" },
    { label: "Aplicar", value: "aplicar" },
  ];

  useEffect(() => {
    if (isVisibleModal) {
      document.body.style.overflow = "hidden";
      setTimeout(() => {
        if (scrollToFilter === "sellers" && sellerRef.current) {
          sellerRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisibleModal, scrollToFilter]);

  useEffect(() => {
    if (isVisibleModal) {
      previousScrollYRef.current = window.scrollY;

      document.body.style.position = "fixed";
      document.body.style.top = `-${previousScrollYRef.current}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    }

    return () => {
      const scrollY = previousScrollYRef.current;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      document.body.style.overflow = "";

      window.scrollTo(0, scrollY);
    };
  }, [isVisibleModal]);

  useEffect(() => {
    if (filterAction === "apply" || filterAction === "clean") {
      const timer = setTimeout(() => {
        onClose();
        setFilterAction("default");
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [filterAction]);

  // ⚠️ Hook condicional resolvido: agora este `return` está após todos os hooks
  if (!isVisibleModal) return null;

  const handleIsVisible = () => {
    onClose();
  };

  const onFilterAction = (value: string) => {
    setSelected(value);
    if (value === "apply" || value === "clean") {
      setFilterAction(value);
    }
  };

  const modalContent = (
    <DivFooterModalBackground>
      <DivFooterModal>
        <FilterModalHeaderMobile isVisible={isVisibleModal}>
          <Button
            onClick={handleIsVisible}
            icon={<FaArrowLeft />}
            color="white"
            size="ghost"
          />
          <div
            onClick={(e) => {
              if (!isVisibleModal) {
                e.stopPropagation();
              }
            }}
          >
            <FieldSearchMobile isVisible={isVisibleModal}>
              <FilterModalModalHeader>
                <IconContent />
                <InfoContent>
                  <Typography color={theme.colors.white} variant="h2">
                    Filtros
                  </Typography>
                  <Typography color={theme.colors.white} variant="label">
                    Selecione os filtros desejados
                  </Typography>
                </InfoContent>
              </FilterModalModalHeader>
            </FieldSearchMobile>
          </div>
        </FilterModalHeaderMobile>
        <FilterModalModalContent>
          <FlightsFilter actionFilter={filterAction} />
        </FilterModalModalContent>
        <FilterModalModalFooter>
          <GroupButton
            selectedValue={selected}
            onChange={onFilterAction}
            options={[
              { label: "Limpar", value: "clean" },
              { label: "Aplicar", value: "apply", isPrimary: true },
            ]}
          />
        </FilterModalModalFooter>
      </DivFooterModal>
    </DivFooterModalBackground>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};
